// import type { AddCustomerForInsuranceRememberPayload, getCusomterType } from "./types.js";


// export const GetCustomer = (params: getCusomterType | undefined) => ['getCustomer'] as const


// export const getCustomerInfo = () => ['getCustomerInfo'] as const

// export const AddCustomerForInsuranceRememberKey = (params: AddCustomerForInsuranceRememberPayload) => ['addCustomerForInsuranceRememberKey', params] as const

// export const GetPlaneCustomerKey = () => ["GetPlaneCustomer"]

// export const GetCustomerListVisitorkey = () => ["customer", "visitor", "customers"];


import type { AddCustomerForInsuranceRememberPayload, getCusomterType } from "./types.js";

export const GetCustomer = (params: getCusomterType | undefined) => ['getCustomer'] as const

export const getCustomerInfo = () => ['getCustomerInfo'] as const

export const AddCustomerForInsuranceRememberKey = (params: AddCustomerForInsuranceRememberPayload) => ['addCustomerForInsuranceRememberKey', params] as const

export const GetPlaneCustomerKey = () => ["GetPlaneCustomer"]

export const GetCustomerListVisitorkey = () => ["customer", "visitor", "customers"];

// ⭐ جدید
export const RequestRegisterLegalkey = () => ["customer", "visitor", "requestRegisterLegal"];
export const RequestRegisterCharitykey = () => ["customer", "visitor", "requestRegisterCharity"];
export const GetPlanForCustomerKey = (customerId: number) =>
    ["customer", "visitor", "planForCustomer", customerId] as const;
  
  export const ChangePlanForCustomerKey = () =>
    ["customer", "visitor", "changePlanForCustomer"] as const;
  export const GetVisitorPerformanceKey = () =>
    ["customer", "visitor", "performance"] as const;
  export const GetCustomerPerformanceKey = () =>
    ["customer", "login", "performance"] as const;
  export const GetCustomerDetailForVisitorKey = (customerId: number) =>
    ["customer", "visitor", "detail", customerId] as const;
  export const GetAverageVisitorKey = () => ["GetAverageVisitor"];
  // core/services/auth/key.ts
export const GetAverageCustomerKey = () => ["GetAverageCustomer"];
